export default {"src":"/login-app/[GIT_HASH]/_next/static/media/workspace.2bc3681b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};